
import appMode from "./appMode";

//-- 1 - localhost, 2 - development, 3 - production
let baseAPIURL = appMode === "1" ? "http://localhost:8115" :
// appMode === "2" ? "https://auditvista.com/kalakriya-dev-api/" : 
appMode === "2" ? "https://auditvista.com/kalakriya-live-api/":
 appMode === "3" &&  "https://kalakriya.com/kalakriya-live-api-v2/"

export default baseAPIURL